import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-floating-call',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-call.html',
  styleUrl: './floating-call.scss'
})
export class FloatingCallComponent implements OnInit {
  isVisible = false;
  isExiting = false;
  private exitTimeout: any;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    // Component initialization
  }

  t(key: string): string {
    return this.languageService.t(key);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const shouldBeVisible = window.pageYOffset > 300;
    
    if (shouldBeVisible && !this.isVisible && !this.isExiting) {
      // Button is becoming visible
      this.isVisible = true;
      this.isExiting = false;
    } else if (!shouldBeVisible && this.isVisible && !this.isExiting) {
      // Button is becoming hidden - start exit animation
      this.isExiting = true;
      this.exitTimeout = setTimeout(() => {
        this.isVisible = false;
        this.isExiting = false;
      }, 400); // Match animation duration
    }
  }

  ngOnDestroy(): void {
    if (this.exitTimeout) {
      clearTimeout(this.exitTimeout);
    }
  }
}



